import {thumbsUpSvg as Icon__small__thumbsUpSvg} from '../Icon__small/Icon__small--thumbsUp.js'
import {thumbsUpSvg as Icon__xsmall__thumbsUpSvg} from '../Icon__xsmall/Icon__xsmall--thumbsUp.js'

export var thumbsUp = {
  name: 'thumbsUp',
  category: 'icon',
  colorable: true,
  svg: Icon__small__thumbsUpSvg,
  alt: {
    Icon__small: Icon__small__thumbsUpSvg,
    Icon__xsmall: Icon__xsmall__thumbsUpSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
